import { render, staticRenderFns } from "./RouteWrapper.vue?vue&type=template&id=7d928fe3&"
import script from "./RouteWrapper.vue?vue&type=script&lang=js&"
export * from "./RouteWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports